export default __webpack_public_path__ + "static/media/hslPDF.0b80e2b5.svg";